// @flow

import React, { type Node } from 'react';

import { InformationAccordionBody } from './information-accordion-body';

export function DepositInformation(): Node {
  return <InformationAccordionBody label="Punto de Pago" options={OPTIONS} />;
}

const OPTIONS = {
  'BBVA': [
    'Indica que vas a pagar un servicio de PAGOEFECTIVO, brinda la moneda y el código CIP.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'BCP': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO (código de empresa 02186), brinda la moneda y el código CIP.',
    ' Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
    'IMPORTANTE: Las Agencias BCP (Ventanilla) tienen un cargo adicional de 1 sol.',
  ],
  'Interbank': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO, brinda la moneda y el código CIP.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
    'IMPORTANTE: Los Money Market (Vivanda y Plaza Vea) tienen un recargo adicional de 2 soles y solo aceptan SOLES.',
  ],
  'Scotiabank': [
    'Indica que vas a pagar un servicio de PAGOEFECTIVO, brinda la moneda y el código CIP.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'Caja Arequipa': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO, brinda la moneda y el código CIP',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'BanBif': [
    'Indica que vas a pagar un servicio de PAGOEFECTIVO, brinda la moneda y el código CIP.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'Western Union': [
    'Indica que vas a pagar un servicio de PAGOEFECTIVO, brinda la moneda y el código CIP.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO',
  ],
  'Kasnet': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO en soles y brinda el código CIP',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO',
  ],
  'Fullcarga': [
    'Indique que va realizar un pago a la empresa PAGOEFECTIVO y el servicio PAGOEFECTIVO SOLES',
    'Indique el código CIP, el importe a pagar en soles.',
    'Verifica que el comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'Disashop': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO y brinda el Código CIP.',
    'Verifica que el SMS del comprobante indique el pago a PAGOEFECTIVO',
  ],
  'Red Digital': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO y brinda el Código CIP y tu nro. de celular.',
    'Verifica que el SMS del comprobante indique el pago a PAGOEFECTIVO.',
  ],
  'Money Gram': [
    'Indica que vas a pagar un servicio a PAGOEFECTIVO y brinda el Código CIP.',
    'Verifica que el SMS del comprobante indique el pago a PAGOEFECTIVO',
  ],
  'TAMBO+': [
    'Realiza tus operaciones en el TAMBO+ e través del agente BBVA',
  ],
};
